// extracted by mini-css-extract-plugin
export default {"body":"otp-code-screen_body__3c5ti","email-line":"otp-code-screen_email-line__yl-QK","inline-error":"otp-code-screen_inline-error__Fo-1e","hint":"otp-code-screen_hint__GG+rm"};